var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid pt-3 pb-3"},[_c('div',{staticClass:"content-area"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }